import {Component, OnDestroy} from '@angular/core';
import {URLSearchParams} from '@angular/http';
import {BookingService} from '../api/booking.service';
import {Booking} from '../shared/model/booking.entity';
import {SpinnerService} from '../spinner/spinner.service';
import {RolePermission} from '../shared/role-permission/role-permission';
import {IndividualClient, Interpreter, OrganisationalRepresentative} from '../shared/model/user.entity';
import {GLOBAL} from '../shared/global';
import {BOOKING_STATE} from '../shared/model/booking-state.enum';
import {BookingInterpreter} from '../shared/model/contact.entity';
import { BookingListMultiSelectService } from './booking-list/booking-list-multi-select.service';
import { SubOrganisationFilterService, SubOrganisation } from '../shared/sub-organisation-filter/sub-organisation-filter.service';
import { switchMap, takeUntil, finalize } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { merge } from 'rxjs/observable/merge';


@Component({
    selector: 'app-booking',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.css']
})
export class BookingComponent implements OnDestroy {
    bookings: Array<Booking> = [];
    totalItems = 0;
    page = GLOBAL.bookingPageNumber;
    search: URLSearchParams;

    private paginatedBookingSubject = new Subject();
    private destroySubject = new Subject();

    constructor(public spinnerService: SpinnerService, public bookingDataService: BookingService,
      private rolePermission: RolePermission,
      private bookingSelector: BookingListMultiSelectService<Booking['id']>,
      private subOrganisationFilter: SubOrganisationFilterService) {
    }

    ngOnDestroy() {
      this.destroySubject.next();
    }

    setActiveFilter(activeFilter: string) {
      if (GLOBAL.activeFilter !== activeFilter) {
        this.bookingSelector.deselectAll();
      }
        GLOBAL.activeFilter = activeFilter;
        this.onPageEmit(1);
    }
    isActiveFilter(activeFilter: string) {
        return GLOBAL.activeFilter === activeFilter;
    }
    onPageEmit($event) {
        GLOBAL.bookingPageNumber = $event.page_number;
        GLOBAL.bookingPageSize = $event.page_size;
        this.getPaginatedBooking();
    }
    isCurrentUserInterpreter(): boolean {
        return Boolean(GLOBAL.currentUser instanceof Interpreter);
    }
    getPaginatedBooking() {
      this.paginatedBookingSubject.next();

        this.search = GLOBAL.getSearchParameter();
        this.search.set('sub_org', this.subOrganisationFilter.selected.name);
        if (this.isCurrentUserInterpreter() && this.search.get('filter[interpreter_statuses]') !== JSON.stringify(GLOBAL.activeFilter)) {
            this.search.set('filter[interpreter_statuses]', JSON.stringify([GLOBAL.activeFilter]));
        }
        GLOBAL.bookingPageNumber = this.page = ( JSON.stringify(GLOBAL.oldSearchParameter.paramsMap) === JSON.stringify(this.search.paramsMap)) ?
            GLOBAL.bookingPageNumber : 1 ;
        GLOBAL.oldSearchParameter = this.search;
        this.subOrganisationFilter.selected$.pipe(
          switchMap((subOrganisation: SubOrganisation) => {
            this.spinnerService.requestInProcess(true);
            this.search.set('sub_org', subOrganisation.name);
            return this.bookingDataService.fetchPaginatedBookings(GLOBAL.bookingPageNumber, GLOBAL.bookingPageSize, this.search)
              .pipe(finalize(() => this.spinnerService.requestInProcess(false)));
          }),
          takeUntil(merge(this.paginatedBookingSubject, this.destroySubject))
        )
            .subscribe((res: any) => {
                    if (res.status === 200) {
                        this.bookings = [];
                        this.totalItems = Boolean(res.data.paginates) ? res.data.paginates.total_records : res.data.bookings.length;
                        for (let o of res.data.bookings) {
                            if (Boolean(!this.rolePermission.isDataRestrictedForCurrentUser('booking-management', o.created_by.type))
                                || (GLOBAL.currentUser instanceof OrganisationalRepresentative && GLOBAL.currentUser.id === o.created_by.id)
                                || (GLOBAL.currentUser instanceof IndividualClient && GLOBAL.currentUser.id === o.created_by.id)
                                || o.interpreters_attributes.filter(int =>
                                    int.id === GLOBAL.currentUser.id).length > 0) {
                                let b = new Booking();
                                b.fromJSON(o);
                                let currentInt: BookingInterpreter;
                                b.interpreters.filter(int => int.id === GLOBAL.currentUser.id)
                                    .map(int => currentInt = int);
                                if (GLOBAL.currentUser instanceof Interpreter && Boolean(currentInt)
                                    && b.state === BOOKING_STATE.Allocated
                                    && (currentInt.state === 'Invited' ||
                                        currentInt.state === 'Rejected')) {
                                    continue;
                                } else {
                                    this.bookings.push(b);
                                }
                            }
                        }
                        this.page = GLOBAL.bookingPageNumber;
                    }
                },
                err => {}
            )
        ;
    }

}



// WEBPACK FOOTER //
// ./src/app/booking-management/booking.component.ts